import React from 'react';
import { FiMenu, FiBell, FiSearch } from 'react-icons/fi';
import { useAuth } from '../../hooks/useAuth';

const Topbar = ({ toggleSidebar }) => {
  const { user, logout } = useAuth();

  return (
    <>
      <style>{`
       .topbar { background: #FFF; padding: 16px 30px; box-shadow: 0 2px 10px rgba(0,0,0,0.04); display: flex; align-items: center; justify-content: space-between; position: sticky; top: 0; z-index: 999; }
       .topbar-left { display: flex; align-items: center; gap: 20px; }
       .menu-btn { display: none; background: none; border: none; font-size: 24px; color: #64748B; cursor: pointer; }
       .search-box { display: flex; align-items: center; gap: 10px; background: #F1F5F9; padding: 10px 16px; border-radius: 10px; width: 300px; }
       .search-box input { border: none; background: none; outline: none; flex: 1; font-size: 14px; }
       .topbar-right { display: flex; align-items: center; gap: 20px; }
       .icon-btn { position: relative; background: #F1F5F9; border: none; width: 40px; height: 40px; border-radius: 10px; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #64748B; transition: all 0.3s ease; }
       .icon-btn:hover { background: #3B82F6; color: #FFF; }
       .badge { position: absolute; top: -4px; right: -4px; background: #EF4444; color: #FFF; width: 18px; height: 18px; border-radius: 50%; font-size: 10px; font-weight: 700; display: flex; align-items: center; justify-content: center; }
       .profile { display: flex; align-items: center; gap: 12px; cursor: pointer; padding: 6px 12px; border-radius: 10px; transition: all 0.3s ease; }
       .profile:hover { background: #F1F5F9; }
       .avatar { width: 40px; height: 40px; border-radius: 50%; background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%); display: flex; align-items: center; justify-content: center; color: #FFF; font-weight: 700; }
       .profile-info h4 { font-size: 14px; font-weight: 700; color: #0F172A; margin: 0; }
       .profile-info p { font-size: 12px; color: #64748B; margin: 0; }
        @media (max-width: 768px) {.menu-btn { display: block; }.search-box { display: none; } }
      `}</style>
      <header className="topbar">
        <div className="topbar-left">
          <button className="menu-btn" onClick={toggleSidebar}><FiMenu /></button>
          <div className="search-box">
            <FiSearch />
            <input type="text" placeholder="Search..." />
          </div>
        </div>
        <div className="topbar-right">
          <button className="icon-btn">
            <FiBell />
            {/* <span className="badge">3</span> */}
          </button>
          <div className="profile" onClick={logout}>
            <div className="avatar">{user?.name?.[0]}</div>
            <div className="profile-info">
              <h4>{user?.name}</h4>
              <p>Admin</p>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};
export default Topbar;